import React from "react";
import { altRecTimer, frameCallProfile, getCurrentCallDetail } from "../../../base/callService/common";
import { calldetail } from "../../../models/callModel";
import styles from "./scss/numberconnecting.module.scss";

type DialConnectingProps = {
  callDetail: calldetail[];
}
export default function DialConnecting({callDetail}:DialConnectingProps) {

  let userData:any = frameCallProfile(getCurrentCallDetail()||{});
  
  return (
    <>
      <div className={styles.dialpadmainconnecting}>
        <h3>{ userData?.callerName }</h3>
        <h4>{userData?.ext}</h4>
        {/* <h5>connecting</h5> */}


        <h5>{callDetail[0]?.connectingStatus!=='Attended'&&callDetail[0]?.bound === 'OUT'?callDetail[0]?.connectingStatus:altRecTimer(userData?.callduration)}<span>HD</span></h5>


      </div>
    </>
  );
};

